import React from 'react'

class DeferredRender extends React.Component {
  state = { visible: false }

  componentDidMount() {
    if (!('IntersectionObserver' in window)) {
      this.setState({ visible: true })
      return
    }

    this.observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.setState({ visible: true })
          this.observer.disconnect()
        }
      },
      { rootMargin: '1200px 0px' }
    )
    this.observer.observe(this.container)
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  render() {
    return (
      <div className={this.props.className} ref={element => { this.container = element }}>
        {this.state.visible ? this.props.children : null}
      </div>
    )
  }
}

export default DeferredRender
